import './article.css';

const Article = () => {
  return (
    <div>
      
    </div>
  )
}

export default Article
